<template lang="pug">
  section.faq
    .content
      h2.title {{ $t('faq.title') }}

      SpoilerItem(v-for="(content, index) in $t('faq.list')", :key="index")
        template(slot="spoiler_title")
          div(v-html="content.question")
        div(v-html="content.answer")

</template>

<script>
import SpoilerItem from "@godweb/frontend-base/src/components/spoiler/SpoilerItem";
export default {
  name: "Faq",

  components: {
    SpoilerItem,
  },
};
</script>
